import { render, staticRenderFns } from "./edit-model.vue?vue&type=template&id=2ff7e9ea&scoped=true&"
import script from "./edit-model.vue?vue&type=script&lang=js&"
export * from "./edit-model.vue?vue&type=script&lang=js&"
import style0 from "./edit-model.vue?vue&type=style&index=0&id=2ff7e9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7e9ea",
  null
  
)

export default component.exports